import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from './alert.service';
import { Alert } from './alert.model';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-alert',
  standalone: true,
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
   imports: [CommonModule]
})
export class AlertComponent implements OnInit, OnDestroy {
  alert?: Alert;
  private subscription!: Subscription;

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.onAlert().subscribe(
        (alert: Alert) => { this.alert = alert; });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}